<h2 mat-dialog-title class="dialog-header">
  <span>Configuracion</span>
  <button mat-icon-button aria-label="Close" (click)="activeModal.close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="dialog-content">
  <div class="form-grid two-columns">
    <mat-form-field appearance="outline">
      <mat-label>Key</mat-label>
      <input matInput [(ngModel)]="config.key" [disabled]="!isNew">
    </mat-form-field>

    <div class="full-span">
      <app-config-field
        [config]="configFieldModel"
        [value]="config.value"
        (valueChange)="config.value = $event">
      </app-config-field>
    </div>

    <mat-form-field appearance="outline">
      <mat-label>Type</mat-label>
      <mat-select [(ngModel)]="config.type">
        <mat-option value="string">String</mat-option>
        <mat-option value="number">Number</mat-option>
        <mat-option value="boolean">Boolean</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Data Source</mat-label>
      <mat-select [(ngModel)]="config.dataSource">
        <mat-option value="SERVER">SERVER</mat-option>
        <mat-option value="KIOSK">KIOSK</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-span">
      <mat-label>Description</mat-label>
      <textarea matInput rows="5" [(ngModel)]="config.description"></textarea>
    </mat-form-field>

    <div class="full-span restriction-card">
      <div class="restriction-card-header">
        <h3>Restrictions</h3>
        <span>Configuracion visual del campo</span>
      </div>

      <div class="form-grid two-columns">
        <mat-form-field appearance="outline">
          <mat-label>Frontend</mat-label>
          <mat-select [(ngModel)]="firstRestriction.frontend" (ngModelChange)="updateRestrictionText()">
            <mat-option *ngFor="let type of frontendTypes" [value]="type">
              {{ type }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Restriction type</mat-label>
          <mat-select [(ngModel)]="firstRestriction.type" (ngModelChange)="updateRestrictionText()">
            <mat-option *ngFor="let type of restrictionTypes" [value]="type">
              {{ type }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Min</mat-label>
          <input matInput type="number" [(ngModel)]="firstRestriction.min" (ngModelChange)="updateRestrictionText()">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Max</mat-label>
          <input matInput type="number" [(ngModel)]="firstRestriction.max" (ngModelChange)="updateRestrictionText()">
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-span">
          <mat-label>Options</mat-label>
          <input
            matInput
            [ngModel]="restrictionOptionsText"
            (ngModelChange)="restrictionOptionsText = $event"
            placeholder="uno, dos, tres">
          <mat-hint>Separadas por comas. Util para SELECT o FILE.</mat-hint>
        </mat-form-field>
      </div>
    </div>

    <mat-form-field appearance="outline" class="full-span">
      <mat-label>Restriction (JSON)</mat-label>
      <textarea matInput rows="8" [(ngModel)]="restrictionText" (blur)="syncRestrictionFromJson()"></textarea>
    </mat-form-field>

    <mat-checkbox [(ngModel)]="config.encrypted">Encrypted</mat-checkbox>
    <mat-checkbox [(ngModel)]="config.editable">Editable</mat-checkbox>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <div class="dialog-actions-spread">
    <button mat-stroked-button color="warn" (click)="delete()">Eliminar</button>
    <button mat-raised-button color="primary" (click)="confirm()">Guardar</button>
  </div>
</mat-dialog-actions>
